<script setup lang="ts">
import useMatestoreStore from '@/store/matestoreStore';
import { computed, onMounted, ref, watch } from 'vue';
import MateEmpty from '@/components/MateEmpty.vue';
import useGlobalStore from '@/store/globalStore';
const microStore = useMatestoreStore();
const globalStore = useGlobalStore();
const elRef = ref<HTMLElement | null>(null);
let timeoutId: number | undefined = undefined;
const defLoadIm = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  // @ts-ignore
  timeoutId = setTimeout(async () => {
    console.log('start loading im', elRef.value);
    const micro = await microStore.loadImMicro(elRef.value as HTMLElement);
    if (micro) {
      micro._microAppInfo.mountPromise
        .then(() => {
          console.log('remount im success');
        })
        .catch((err) => {
          console.log('remount im failed', err);
        });
    }
  }, 3000);
};
onMounted(() => {
  /*load im after 3seconds*/
  defLoadIm();
});

watch(
  () => microStore.showIm,
  () => {
    if (microStore.showIm && !microStore.imMicro.mounted) {
      defLoadIm();
    }
  }
);
</script>

<template>
  <div
    :class="{
      'im-container': true,
    }"
    id="im-frame-viewport"
    ref="elRef"
  >
    <mate-empty status="loading" />
  </div>
</template>

<style scoped lang="scss">
.im-container {
  background: #fff;
  height: 100%;
  overflow: hidden;
  border-radius: 12px 0px 0px 0px;
}
.im-refresh-button {
  position: fixed;
  right: 30px;
  top: 80px;
  z-index: 101;
}
</style>
